import { useState } from 'react';
import { Box, Stack } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FormLanguageInputController, FormSwitchController, ImageUploadUtil } from '@/components';
import { IMAGES, usePostImage } from '@/core';
import { LanguageTypes } from '@/features';
import { TOfferType } from '@/features/foodCategory/types/OfferTypes';
import palette from '@/theme/palette.ts';

import { styles } from './styles.ts';

export const OfferModal = ({
  imageId,
  setIsNewImageUploadInProgress,
}: {
  imageId: number | undefined;
  setIsNewImageUploadInProgress: (state: boolean) => void;
}) => {
  const {
    setValue,
    formState: { errors },
  } = useFormContext<TOfferType>();
  const imageSrc = imageId ? `${window.API_URL}/${IMAGES}/${imageId}` : '';

  const { t } = useTranslation();

  const [selectedNameLang, setSelectedNameLang] = useState<LanguageTypes>('cs');

  const onSuccessImageUpload = ({ id }: { id: number }) => {
    setValue('oldImageId', imageId);
    setValue('image', id);
    setIsNewImageUploadInProgress(false);
  };

  //queries
  const { mutate: postNewImage } = usePostImage({ onSuccess: onSuccessImageUpload });

  const getUploadedImage = (uploadedImage: File) => {
    setIsNewImageUploadInProgress(true);
    postNewImage(uploadedImage);
  };

  return (
    <Stack
      direction="column"
      justifyContent="center"
      alignItems="flex-start"
      sx={{ ...styles.container, background: palette.surface.white }}
    >
      <FormLanguageInputController
        label="Název"
        controllerName="name"
        selectedLanguage={selectedNameLang}
        setSelectedLanguage={setSelectedNameLang}
        error={!!errors.name}
        errorText={
          errors.name?.cs?.message ||
          errors.name?.en?.message ||
          errors.name?.de?.message ||
          t('GLOBAL.MIN_ONE_LANG')
        }
      />

      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-start"
        sx={{ width: '100%', marginTop: '8px' }}
      >
        <FormSwitchController
          controllerName="showImmediately"
          label={t('SWITCHER.SHOW_IMMEDIATELY')}
        />
      </Stack>

      <Box style={styles.imageUploadBox}>
        <ImageUploadUtil getUploadedImage={getUploadedImage} initialImageSrc={imageSrc} />
      </Box>
    </Stack>
  );
};
